

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ScoreButton extends Vue {
  @Prop({ default: false }) private closed!: 0 | 1;
  @Prop({ required: true }) private value!: number;
  @Prop({ required: true }) private onClick!: Function;

  get className() {
    if (this.closed) return 'value-X';
    const val = Math.min(this.value, 4);
    return `value-${val}`;
  }

  get display() {
    return this.value <= 3 ? '' : (this.value - 3).toString();
  }
}
